var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentAutoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 28,
    viewBox: "0 0 35 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33716 22.8174C4.33716 25.4436 6.26016 27.573 8.63256 27.573C11.0044 27.573 12.9274 25.4436 12.9274 22.8174H4.33716Z",
    fill: "#C5F4E0",
    stroke: "#63768D",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3401 22.8174C22.3401 25.4436 24.2631 27.573 26.6349 27.573C29.0073 27.573 30.9303 25.4436 30.9303 22.8174H22.3401Z",
    fill: "#C5F4E0",
    stroke: "#63768D",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 13H2.81651C1.81387 13 1 12.3896 1 11.6383V11.3624C1 10.6097 1.81387 10 2.81651 10H5V13Z",
    fill: "#C5F4E0",
    stroke: "#63768D",
    strokeWidth: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 13H32.6373C33.3897 13 34 12.3896 34 11.6383V11.3624C34 10.6097 33.3897 10 32.6373 10H31V13Z",
    fill: "#C5F4E0",
    stroke: "#63768D",
    strokeWidth: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5564 11.7703C31.6624 11.9185 31.7247 12.0999 31.7247 12.2958V21.9126C31.7247 22.4118 31.3191 22.8174 30.8199 22.8174H4.48952C3.98972 22.8174 3.58472 22.4118 3.58472 21.9126V12.2958C3.58472 12.0326 3.69708 11.7956 3.87647 11.6303L7.16594 4.45365C8.27894 2.10045 10.6489 0.599854 13.2517 0.599854H21.8473C24.3967 0.599854 26.7271 2.03925 27.8677 4.31925L31.5564 11.7703Z",
    fill: "#81E5BD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5564 11.7703L31.1083 11.9922L31.1262 12.0283L31.1497 12.0611L31.5564 11.7703ZM3.87647 11.6303L4.21531 11.998L4.28916 11.9299L4.331 11.8386L3.87647 11.6303ZM7.16594 4.45365L6.71391 4.23986L6.71141 4.24532L7.16594 4.45365ZM27.8677 4.31925L28.3158 4.09742L28.3149 4.09555L27.8677 4.31925ZM31.1497 12.0611C31.197 12.1273 31.2247 12.2076 31.2247 12.2958H32.2247C32.2247 11.9921 32.1277 11.7096 31.9632 11.4795L31.1497 12.0611ZM31.2247 12.2958V21.9126H32.2247V12.2958H31.2247ZM31.2247 21.9126C31.2247 22.1357 31.043 22.3174 30.8199 22.3174V23.3174C31.5953 23.3174 32.2247 22.688 32.2247 21.9126H31.2247ZM30.8199 22.3174H4.48952V23.3174H30.8199V22.3174ZM4.48952 22.3174C4.26608 22.3174 4.08472 22.1359 4.08472 21.9126H3.08472C3.08472 22.6878 3.71336 23.3174 4.48952 23.3174V22.3174ZM4.08472 21.9126V12.2958H3.08472V21.9126H4.08472ZM4.08472 12.2958C4.08472 12.178 4.13437 12.0726 4.21531 11.998L3.53763 11.2626C3.25979 11.5187 3.08472 11.8872 3.08472 12.2958H4.08472ZM4.331 11.8386L7.62047 4.66199L6.71141 4.24532L3.42194 11.422L4.331 11.8386ZM7.61793 4.66743C8.64827 2.48901 10.8423 1.09985 13.2517 1.09985V0.0998535C10.4556 0.0998535 7.90961 1.7119 6.71394 4.23987L7.61793 4.66743ZM13.2517 1.09985H21.8473V0.0998535H13.2517V1.09985ZM21.8473 1.09985C24.2075 1.09985 26.3647 2.43236 27.4206 4.54295L28.3149 4.09555C27.0896 1.64615 24.586 0.0998535 21.8473 0.0998535V1.09985ZM27.4196 4.54109L31.1083 11.9922L32.0045 11.5485L28.3158 4.09742L27.4196 4.54109Z",
    fill: "#63768D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03665 11.7095C6.7594 11.7095 6.57186 11.4743 6.67671 11.2603L9.28172 5.94315C10.1702 4.37085 12.0618 2.70947 14.1399 2.70947H21.0005C23.0359 2.70947 24.8956 4.33059 25.8063 5.85359L28.6145 11.2535C28.7264 11.4688 28.5377 11.7095 28.2578 11.7095H7.03665Z",
    fill: "#C5F4E0",
    stroke: "#63768D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3736 20.0014H15.3108C14.8578 20.0014 14.4888 19.6336 14.4888 19.1794V18.7342C14.4888 18.28 14.8578 17.9122 15.3108 17.9122H20.3736C20.8278 17.9122 21.1956 18.28 21.1956 18.7342V19.1794C21.1956 19.6336 20.8278 20.0014 20.3736 20.0014Z",
    fill: "#63768D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6916 15.4159L25.9298 17.5453C25.5356 17.8345 24.9656 17.7703 24.6554 17.4013L24.1448 16.7917C23.6768 16.2331 24.1016 15.4159 24.8588 15.4159H28.6916Z",
    stroke: "#63768D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.61694 15.4159L9.37874 17.5453C9.77354 17.8345 10.3435 17.7703 10.6531 17.4013L11.1643 16.7917C11.6323 16.2331 11.2075 15.4159 10.4503 15.4159H6.61694Z",
    stroke: "#63768D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9111 15.4158H7.05151",
    stroke: "#63768D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentAutoIcon);
export default __webpack_public_path__ + "static/media/payment-auto-icon.e1543ace.svg";
export { ForwardRef as ReactComponent };